import { useState, useCallback } from "react";

export function useSearchFilter() {
  const [searchTerm, setSearchTerm] = useState("");

  const applyFilter = useCallback((data, fields) => {
    if (!searchTerm || !data) return data;
    const term = searchTerm.toLowerCase();
    return data.filter(item =>
      fields.some(field => {
        const val = field.getValue(item);
        return val !== null && val !== undefined && val.toString().toLowerCase().includes(term);
      })
    );
  }, [searchTerm]);

  return { searchTerm, setSearchTerm, applyFilter };
}